<!-- Header -->
<div class="card-header card-header-grid">
  <!-- Search -->
  <div class="input-group input-lined" role="search">
    <div class="input-group-text">
      <i role="img" class="fa fa-search text-muted" aria-hidden="true"></i>
    </div>
    <input
      class="form-control"
      type="search"
      placeholder="{{ 'general.search' | translate }}"
      attr.aria-label="{{ 'general.search' | translate }}"
      [(ngModel)]="filterTerm"
    />
  </div>
  <!-- End Search -->

  <div class="d-flex justify-content-end align-items-center">
    <div>
      {{ (tableData | recursiveFilter: filterTerm)?.length }}
      {{ 'general.total' | translate }}
    </div>

    <div class="btn-group mb-3" dropdown *ngIf="bulkActions?.length">
      <button
        class="btn btn-sm btn-white dropdown-toggle"
        type="button"
        aria-controls="bulkAction4"
        dropdownToggle
      >
        {{ 'general.bulkActions' | translate }}
      </button>

      <ul
        *dropdownMenu
        class="dropdown-menu dropdown-menu-right"
        role="menu"
        id="bulkAction4"
      >
        <li *ngFor="let bulkAction of bulkActions">
          <a
            class="dropdown-item"
            href="javascript:;"
            (click)="onClickBulkAction(bulkAction)"
          >
            {{ 'general.' + bulkAction | translate }}
          </a>
        </li>
      </ul>
    </div>
  </div>

  <!-- End Row -->
</div>
<!-- End Header -->

<!-- Table -->
<div class="table-responsive">
  <table
    class="table table-borderless table-hover table-striped table-nowrap"
    [mfData]="tableData | recursiveFilter: filterTerm"
    #dataTable="mfDataTable"
    [mfRowsOnPage]="25"
  >
    <thead class="table-light">
      <tr>
        <th scope="col" (click)="onToggleAllChecked()" class="cursor-pointer">
          <input
            type="checkbox"
            class="form-check-input"
            [checked]="allCheckedToggle"
            attr.aria-label="{{ 'general.selectAll' | translate }}"
          />
        </th>
        <th scope="col" style="width: 25%">
          <mfDefaultSorter by="key" (click)="onSortfieldClick('key')">
            {{ 'general.key' | translate }}

            <i
              class="fa ms-1"
              role="img"
              [ngClass]="{
                'fa-sort-down': sortingField == 'key_asc',
                'fa-sort-up ': sortingField == 'key_desc',
                'fa-sort text-muted  opacity-50':
                  sortingField !== 'key_asc' && sortingField !== 'key_desc'
              }"
              attr.aria-label="{{ 'wcag.sort' | translate }}"
            >
            </i>
          </mfDefaultSorter>
        </th>
        <th scope="col" style="width: 75%">
          <mfDefaultSorter by="value" (click)="onSortfieldClick('value')">
            {{ 'general.value' | translate }}

            <i
              class="fa ms-1"
              role="img"
              [ngClass]="{
                'fa-sort-down ': sortingField == 'value_asc',
                'fa-sort-up ': sortingField == 'value_desc',
                'fa-sort text-muted  opacity-50':
                  sortingField !== 'value_asc' && sortingField !== 'value_desc'
              }"
              attr.aria-label="{{ 'wcag.sort ' | translate }}"
            >
            </i>
          </mfDefaultSorter>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let item of dataTable.data; let i = index"
        class="cursor-pointer"
      >
        <td
          (click)="onCheckRow(item)"
          class="cursor-pointer"
          style="max-width: 60px"
        >
          <input
            type="checkbox"
            class="form-check-input"
            [checked]="this.checkedIds.get(item.id)"
            attr.aria-label="{{ 'wcag.selectThis' | translate }}"
          />
        </td>
        <td
          (click)="onRowClicked(item)"
          (keyup.enter)="onRowClicked(item)"
          tabindex="0"
          role="link"
          >{{ item.key }}</td
        >
        <td (click)="onRowClicked(item)">{{ item.value }}</td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="6" class="pb-0">
          <mfBootstrapPaginator
            [rowsOnPageSet]="[25, 50, 100]"
          ></mfBootstrapPaginator>
        </td>
      </tr>
    </tfoot>
  </table>
</div>
